/**
 * The destinations the redesigned site sends people to but does not own.
 *
 * One module because the same URL is needed from more than one place and drifting copies are how a
 * footer ends up disagreeing with a page: the donor app is asked for by the Contact page and by the
 * footer's "WebApp" and "Certificates" entries. They were separate placeholders until TEC-3821.
 *
 * The NGO sign-up is deliberately NOT here. It is not a fixed URL: `useNgoAreaUrl` derives the NGO
 * area from the host the visitor is on, so a link followed from `snd` stays in `snd` instead of
 * jumping to production. Every sign-up CTA on the site goes through it.
 */

/** What a donor can answer for themselves: donation status and tax certificate. */
export const DONOR_APP_URL = 'https://app.worldcoo.com';

/** Open positions. Worldcoo publishes them on LinkedIn, not on the site. */
export const JOBS_URL = 'https://www.linkedin.com/company/worldcoo/jobs/';
